<div class="mm-dash-row">
  <div class="mm-dash-cell">
    <h5 class="cell-title">{{ 'SUMMARY' | translate }}</h5>
    <div class="under-title-inner-cell">
      <div class="inner-cell-block">
        <h5>{{ 'TOTAL_CAMPAIGNS' | translate }}</h5>
        <div class="campaign-totals-row">
          <h3>{{ totalActiveCampaignCount }}</h3>
        </div>
      </div>
      <div class="inner-cell-block">
        <h5>{{ 'TOTAL_META_CAMPAIGNS' | translate }}</h5>
        <div class="campaign-totals-row">
          <h3>{{ totalFacebookCampaignCount }}</h3>
        </div>
      </div>
      <div class="inner-cell-block">
        <h5>{{ 'TOTAL_GOOGLE_CAMPAIGNS' | translate }}</h5>
        <div class="campaign-totals-row">
          <h3>{{ totalGoogleCampaignCount }}</h3>
        </div>
      </div>
      <div class="inner-cell-block">
        <h5>{{ 'TOTAL_CLIENTS' | translate }}</h5>
        <div class="campaign-totals-row">
          <h3>{{ this.totalClientCount }}</h3>
        </div>
      </div>
    </div>
    <div class="inner-cell-block">
      <p class="disclaimer-text">
        {{ 'TOTAL_CAMPAIGNS_DISCLAIMER' | translate }}
      </p>
    </div>
  </div>

  <div *ngIf="campValues.length > 0" class="mm-dash-cell">
    <h5 class="cell-title">{{ 'STAGES' | translate }}</h5>
    <div class="under-title-inner-cell">
      <div *ngFor="let item of campValues" class="inner-cell-block">
        <h5>{{ item.state | translate }} {{ 'CAMPAIGNS' | translate }}:</h5>
        <div class="campaign-totals-row">
          <h3>{{ item.count }}</h3>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="(this.totalLeadCount > 0)" class="mm-dash-cell">
    <h5 class="cell-title">{{ 'LEADS' | translate }}</h5>
    <div class="under-title-inner-cell">
      <div class="inner-cell-block">
        <h5>{{ 'TOTAL_LEADS' | translate }}</h5>
        <div class="campaign-totals-row">
          <h3>{{ this.totalLeadCount }}</h3>
        </div>
      </div>
    </div>
    <div class="inner-cell-block">
      <p class="disclaimer-text">
        {{ 'LEAD_METRICS_DISCLAIMER' | translate }}
      </p>
    </div>
  </div>

  <div *ngIf="!tooManyCompanies" class="mm-dash-cell">
    <h5 class="cell-title">{{ 'REPORTING' | translate }}</h5>
    <div class="under-title-inner-cell">
      <form [formGroup]="reportForm" (submit)="onFormSubmit()" class="mm-reporting-form">
        <div>
          <div *ngIf="!isEmptyCompanyGuid" class="g-3 align-items-center mb-3">
            <label class="col-6 mb-2">{{ 'COMPANY_NAME' | translate }}</label>
            <div class="col-6 mb-2">{{ companyData.name }}</div>

            <label class="col-6 mb-2">{{ 'PLATFORMS_LABEL' | translate }}</label>
            <div class="col-auto">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  value="All"
                  name="platforms"
                  formControlName="platforms"
                  id="AllPlatforms"
                  checked
                  (change)="handlePlatformsChange($event, 'All')"
                />
                <label class="form-check-label" for="AllPlatforms">{{ 'ALL' | translate }}</label>
              </div>

              <div *ngFor="let platform of platforms" class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [value]="platform"
                  name="platforms"
                  formControlName="platforms"
                  id="platform_{{ platform }}"
                  (change)="handlePlatformsChange($event, platform)"
                />
                <label class="form-check-label" for="platform_{{ platform }}">{{ platform }}</label>
              </div>
            </div>
          </div>

          <div class="row g-3 align-items-center mb-3">
            <label class="col-12 mb-2">{{ 'PLEASE_SELECT_REPORT_PERIOD' | translate }}</label>
            <div class="col-auto" style="margin-top: 0px !important;">
              <select
                class="form-select mb-2"
                [attr.aria-label]="'PLEASE_SELECT_PERIOD' | translate"
                (change)="onReportPeriodChange(t.value)"
                #t
              >
                <option selected disabled>{{ 'PLEASE_SELECT_PERIOD' | translate }}</option>
                <option
                  type="button"
                  ngbDropdownItem
                  *ngFor="let p of reportPeriods"
                  [value]="p.key"
                  [selected]="selectedReportPeriod == p.key"
                >
                  {{ getReportingPeriodTitle(p.key) }}
                </option>
              </select>
            </div>
            <label class="col-2 mb-2"></label>
          </div>
        </div>

        <div class="col-auto">
          <button type="submit" class="blue-button" style="width: 100% !important;">{{ 'VIEW_ROLLUP_REPORT' | translate }}</button>
        </div>
      </form>
    </div>
  </div>

  <ul ngbNav #nav="ngbNav" [(activeId)]="active" style="width: 24% !important;">
    <li [ngbNavItem]="1"></li>

    <li [ngbNavItem]="3" style="width: 48% !important;">
      <ng-template ngbNavContent style="background-color: white;">
        <div class="la-ball-spin-clockwise la-dark la-3x" *ngIf="!loadCompleted">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div style="background-color: white; border-radius: 0.25rem;">
          <h5 class="cell-title">{{ 'ROLLUP_REPORT' | translate }}</h5>
          <iframe
            #rollupIframe
            style="height: 99vh; padding: 8px;"
            width="100%"
            (load)="onFrameLoadComplete()"
          ></iframe>
        </div>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" style="background-color: transparent; width: 100%;"></div>
</div>
